const productionRouter = [
    {
        path: '/production',
        component: () => import('@/layout/LayoutIndex.vue'),
        meta: { title: '生产管理', icon: 'production', requireAuth: true },
        name: 'production',
        redirect: '/production/plan',
        children: [
          {
            path: '/production/plan',
            component: () => import('@/views/production/productionPlan/ProductionPlanIndex.vue'),
            name: 'productionPlan',
            meta: { title: '生产计划', requireAuth: true }
          },
           {
            path: '/production/processManagement',
            component: () => import('@/views/production/processManagement/processManagementIndex.vue'),
            name: 'processManagement',
            meta: { title: '工序管理', requireAuth: true }
          }
        ]
    },
]

export default productionRouter; 